import shopTraining from '@/images/shop_training.jpg'

function RDCenter() {
  return (
    <div className="grow py-8 px-4 sm:px-12 container mx-auto shadow-md flex gap-8 flex-col main-container-height">
      <div className="w-full mb-12">
        <h2 className="text-grays-dark text-2xl font-bold mb-4">
          Research and Development Center
        </h2>
        <p className="text-grays-dark font-normal mb-4">
          At CTI, we believe great training starts with real world experience. Our Research
          and Development Center brings our industry experts together in one place to
          create, test, and refine the curriculum we deliver to customers every day.
        </p>
        <p className="text-grays-dark font-normal mb-4">
          Inside our 9,000 square foot facility, our team conducts vehicle testing, validates
          repair procedures, evaluates shop equipment, and develops case studies based
          on real service challenges. This hands-on approach helps ensure our training
          stays practical, relevant, and aligned with today’s automotive industry.
        </p>
        <p className="text-grays-dark font-normal mb-4">
          The center features a 50 seat primary classroom for instructor-led training and a
          six bay shop fully equipped with advanced tools and calibration equipment.
        </p>
        <p className="text-grays-dark font-normal">
          Our in house video studio also allows us to produce online courses, enhance
          classroom programs, and stream live events so customers can learn wherever
          they are.
        </p>
      </div>
      <div className="w-full flex flex-col md:flex-row gap-5 justify-center max-h-72">
        <div className="mb-4">
          <img
            src="/images/AL8_3179.webp"
            className="h-full object-contain"
            alt="diagnostic tool"
          />
        </div>
        <div className="mb-4">
          <img
            src="/images/DSC01106.webp"
            className="h-full object-contain"
            alt="diagnostic car hood"
          />
        </div>
        <div className="mb-4">
          <img
            src="/images/DSC00969.webp"
            className="h-full object-contain"
            alt="shop training"
          />
        </div>
      </div>
    </div>
  )
}

export default RDCenter
